import { createActionGroup, props } from '@ngrx/store';
import { PersonnelEntity } from './personnel.entity';
import { PersonnelModel } from '../../model';
import { DeepPartial } from '@core/util';

export type PersonnelInitProps = {
  personnels: PersonnelModel[];
  accessToken: string;
};

export type SetCurrentPersonnelProps = {
  personnel: DeepPartial<PersonnelModel>;
};

export type PersonnelLoadSuccessProps = {
  entities: PersonnelEntity[];
  selectedId?: string;
};

export const PersonnelActions = createActionGroup({
  source: 'Personnel',
  events: {
    Init: props<PersonnelInitProps>(),
    'Set Current Personnel': props<SetCurrentPersonnelProps>(),
    'Load Success': props<PersonnelLoadSuccessProps>(),
    'Load Failure': props<{ error: any }>(),
  },
});
